export const getCurrentCompetencia = (): string => {
  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
  firstDay.setMonth(firstDay.getMonth() - 1);
  return firstDay.toISOString();
}